import React from "react";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

export default function features() {
  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Copyable Code with Two Mandatory Conditions
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="1. An API key must be generated by creating an API through the landing page." />
        </ListItem>
        <ListItem>
          <ListItemText primary="2. An authentication token, available in the browser's cookie section, must be included." />
        </ListItem>
      </List>
    </div>
  );
}
